import React from 'react';

interface MarketingHeroSuspenseFallbackProps {
  posterSrc: string;
}

export const MarketingHeroSuspenseFallback: React.FC<MarketingHeroSuspenseFallbackProps> = ({
  posterSrc
}) => (
  <div className="min-h-screen bg-[#0F335B] [min-height:100dvh]" aria-hidden="true">
    <img
      src={posterSrc}
      alt=""
      className="h-full min-h-screen w-full object-cover [min-height:100dvh]"
      fetchPriority="high"
    />
  </div>
);
